if (!customElements.get('rr-drop-bar')) {
  customElements.define(
    'rr-drop-bar',
    class RrDropBar extends HTMLElement {
      connectedCallback() {
        this.threshold = parseFloat(this.dataset.threshold) || 0;
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        // Keep it visible while its section is selected in the theme editor.
        this.onSelect = (event) => event.target.contains(this) && this.classList.add('is-visible');
        this.onDeselect = (event) => event.target.contains(this) && this.onScroll();
        document.addEventListener('shopify:section:select', this.onSelect);
        document.addEventListener('shopify:section:deselect', this.onDeselect);
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('shopify:section:select', this.onSelect);
        document.removeEventListener('shopify:section:deselect', this.onDeselect);
      }

      onScroll() {
        this.classList.toggle('is-visible', window.scrollY > window.innerHeight * this.threshold);
      }
    }
  );
}
